import { FaHWLibraryHostContext, setFaHWLibraryHost } from 'fa-gui-hw';

/**
 * Host context that Pure1 registers with the fa-gui-hw hardware-visualization library.
 *
 * Shared between the production startup path (initializeApp() in app/initialize-app.ts, run as an
 * APP_INITIALIZER) and the unit-test bootstrap (applyGlobalTestSetupOnce() in
 * testing/global-test-setup.ts) so both register the library with identical configuration before
 * any library class is constructed. The library throws if a class is constructed before a host has
 * been registered, so a new bootstrap path needs the same call.
 */
export const FA_HW_LIBRARY_HOST_CONTEXT: FaHWLibraryHostContext = {
    theme: {
        images: {
            bezel: '/images/logo-bezel.png',
            bezel_x_series: '/images/x_series_bezel.png',
            bezel_helium: '/images/helium_bezel.png',
            // Relative, unlike every sibling. Carried over verbatim from the old
            // array_health theme.js, which had the same quirk — do not "fix" the
            // leading slash without checking how the library resolves it.
            bezel_oxygen: 'images/oxygen_bezel.svg',
            bezel_nickel: '/images/nickel_bezel.svg',
            array_controller: '/images/array-controller-logo.png',
            gray_logo: '/images/logo-gray.png',
            cbs_logo: '/images/cbs.svg',
        },
    },
    contentPath: p => p,
    tooltipScale: 0.9,
    // Pure1 is a read-only multi-array dashboard: no playback mode and
    // no per-array hardware modify permissions, so both getters always
    // return false. This keeps every action button rendered by the
    // library in the disabled/grayed state.
    isPlayback: () => false,
    canModifySystem: () => false,
};

/**
 * Registers the fa-gui-hw library host. Must be called once during startup (production app init
 * or test bootstrap) before any library class is constructed.
 */
export function configureFaHWLibrary(): void {
    setFaHWLibraryHost(FA_HW_LIBRARY_HOST_CONTEXT);
}
